import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-to_be_screened",
  "use": "icon-to_be_screened-usage",
  "viewBox": "0 0 13.679388999938965 12.260072708129883",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 13.679388999938965 12.260072708129883\" id=\"icon-to_be_screened\"><g transform=\"matrix(1,0,0,-1,0,24.520145416259766)\"><path d=\"M0.10687,23.891272708129883Q0.400763,24.492772708129884,1.0687,24.520172708129884L12.6107,24.520172708129884Q13.2786,24.492772708129884,13.5725,23.891272708129883Q13.8397,23.26237270812988,13.4389,22.742772708129884L8.54962,16.617802708129883L8.54962,13.145146708129882Q8.5229,12.625615708129883,8.0687,12.352177908129883Q7.6145,12.133427708129883,7.18702,12.434208708129884L5.4771,13.746712708129882Q5.12977,14.020142708129884,5.12977,14.457642708129882L5.12977,16.617802708129883L0.240458,22.742772708129884Q-0.160305,23.26237270812988,0.10687,23.891272708129883Z\" fill=\"#4B5563\" fill-opacity=\"1\" style=\"mix-blend-mode:passthrough\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/to_be_screened.svg
// module id = Nd5u
// module chunks = 119